const MUTATION = 'mutation';
const MUTATION_DELETE = 'delete';
const MUTATION_UPDATE = 'update';
const MUTATION_APPROVE = 'approve';
const MUTATION_REJECT = 'reject';
const MUTATION_MORE_INFO = 'moreInfo';
const MUTATION_UNDO = 'undo';
const MUTATION_DOWNLOAD = 'download';

export class MutationKey {
  entityKey: any[];

  constructor(...key: any[]) {
    this.entityKey = key;
  }
  getPath() {
    return this.entityKey;
  }

  mutate(key: any) {
    return () => [...this.entityKey, key, MUTATION];
  }

  delete() {
    return this.mutate(MUTATION_DELETE);
  }

  update() {
    return this.mutate(MUTATION_UPDATE);
  }
  approve() {
    return this.mutate(MUTATION_APPROVE);
  }
  reject() {
    return this.mutate(MUTATION_REJECT);
  }
  moreInfo() {
    return this.mutate(MUTATION_MORE_INFO);
  }
  undo() {
    return this.mutate(MUTATION_UNDO);
  }
  download() {
    return this.mutate(MUTATION_DOWNLOAD);
  }
}
